<template>
  <div class="summary-panel">
    <VsLoader :visible="!!panelData.isLoading" />
    <ChartSummarize :title="$t(panelAttr.title)" :total="panelData.total" :totalFormat="panelAttr.totalFormat">
      <template v-if="panelAttr.logo" v-slot:logo>
        <component :is="panelAttr.logo" />
      </template>
      <template v-if="panelAttr.tooltip" v-slot:tooltip>
        <VsTooltip :label="panelAttr.tooltip" />
      </template>
    </ChartSummarize>
    <slot />
  </div>
</template>

<script>
import ChartSummarize from "@/components/dashboard/Chart/chartAndSummary/ChartSummarize";
import CoverageRate from "@/assets/logos/coverage/coverage-rate.svg";
import PageViews from "@/assets/logos/coverage/page-views.svg";

export default {
  components: {
    ChartSummarize,
    CoverageRate,
    PageViews,
  },
  props: {
    panelData: Object, // eslint-disable-line vue/require-default-prop
    panelAttr: Object, // eslint-disable-line vue/require-default-prop
  },
};
</script>

<style scoped lang="scss">
.summary-panel {
  position: relative;
  width: 100%;
  padding: 20px;
}

svg {
  margin-right: 5px;
}
</style>
